import { useDropzone } from "react-dropzone";
import { Box, DataGrid, Grid, Tooltip, Typography } from "../../../components";
import { GrupoServicoService } from "../../../services";
import { useEffect, useRef, useState } from "react";
import { erroCelulaGridServicos } from "../importar-servico";
import { formatPercentage, formatPrice, responseErros } from "../../../utils";
import { value } from "../../../helpers";

const grupoServicoService = new GrupoServicoService();

const ImportarServicoStepper = ({
  activeStep,
  arquivoCsv,
  setArquivoCsv,
  dadosCsv,
  codigosServicoNacionalList,
  classificacoesServicoNacionalList,
  inputErros,
}) => {
  const [gruposServicos, setGruposServicos] = useState([]);
  const csvUpload = useRef(null);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    onDrop: (acceptedFiles) => {
      handleCsvChange(acceptedFiles);
    },
  });

  function handleCsvChange(event) {
    if (event.target) {
      setArquivoCsv(event.target.files[0]);
    } else {
      setArquivoCsv(event[0]);
    }
  }

  const elipsisStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const colunas = [
    {
      field: "nome",
      headerName: "Nome",
      width: 300,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "descricao",
      headerName: "Descrição",
      width: 300,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "precoServico",
      headerName: "Preço do Serviço",
      width: 200,
      sortable: false,
      valueGetter: (params) => formatPrice(params.value),
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "grupoServicoId",
      headerName: "Grupo de Serviço",
      width: 300,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) =>
        value.autoComplete(gruposServicos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "aliquotaTotalSimplesNacional",
      headerName: "Alíquota Total Simples Nacional",
      width: 200,
      valueGetter: (params) => formatPercentage(params.value, 1),
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "estCodigoServicoNacionalId",
      headerName: "Código de Serviço Nacional",
      width: 600,
      valueGetter: (params) => {
        const codigo = value.autoComplete(
          codigosServicoNacionalList,
          params.value,
        );
        return (
          <Box sx={elipsisStyle}>
            {codigo.codigoNacional} - {codigo.descricaoCompleta || ""}
          </Box>
        );
      },
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "estClassificacaoServicoNacionalId",
      headerName: "Classificação de Serviço Nacional",
      width: 600,
      valueGetter: (params) => {
        const classificacao = value.autoComplete(
          classificacoesServicoNacionalList,
          params.value,
        );
        return (
          <Box sx={elipsisStyle}>
            {classificacao.codigoClassificacao} -{" "}
            {classificacao.descricaoCompleta || ""}
          </Box>
        );
      },
      renderCell: (params) => renderCellTratamentoErros(params),
    },
  ];

  useEffect(() => {
    buscarGruposServicos();
  }, []);

  const buscarGruposServicos = () => {
    grupoServicoService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setGruposServicos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const renderCellTratamentoErros = (params) => {
    return erroCelulaGridServicos(params, inputErros) ? (
      <Tooltip
        title={`${params.colDef.headerName} é obrigatório`}
        arrow
        placement="top"
      >
        <i
          className="ph ph-warning"
          style={{ fontSize: 26, color: "#e53935" }}
        />
      </Tooltip>
    ) : (
      params.formattedValue
    );
  };

  switch (activeStep) {
    case 1:
      return (
        <Grid container spacing={2} sx={{ pl: 2, mt: 3 }}>
          <DataGrid
            rows={dadosCsv || []}
            columns={colunas}
            rowCount={dadosCsv?.length || 0}
            disableAcoes
          />
        </Grid>
      );
    default:
      return (
        <Box
          {...getRootProps()}
          sx={{
            width: "100%",
            height: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1em",
            border:
              isDragActive || arquivoCsv
                ? "2px dashed grey"
                : "2px solid transparent",
            borderRadius: 2,
            padding: 2,
            backgroundColor: isDragActive || arquivoCsv ? "#e3f2fd" : "#fafafa",
            ":hover": { backgroundColor: "#e3f2fd", border: "2px dashed grey" },
            cursor: "pointer",
          }}
          onClick={() => csvUpload.current.click()}
        >
          <input
            {...getInputProps()}
            type="file"
            style={{ display: "none" }}
            ref={csvUpload}
            onChange={(event) => handleCsvChange(event.target.files)}
          />
          {arquivoCsv && (
            <i
              className="mb-2 ph-bold ph-check-circle"
              style={{ fontSize: 50, color: "#43a047" }}
            />
          )}
          <h4 style={{ fontWeight: 800, margin: 0 }}>
            {arquivoCsv
              ? "Arquivo Selecionado!"
              : "Arraste e solte ou Clique aqui para importar arquivo CSV/XLS"}
          </h4>
          {arquivoCsv?.name && (
            <div className="mt-2">
              <Typography>{arquivoCsv.name}</Typography>
            </div>
          )}
        </Box>
      );
  }
};

export default ImportarServicoStepper;
